var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "api-root-page" }, [
    _c(
      "div",
      {
        staticClass: "head",
        staticStyle: { position: "relative" },
        style: { height: _vm.routerHeadHeight + "px" }
      },
      [
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.handleTabClick },
            model: {
              value: _vm.activeName,
              callback: function($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName"
            }
          },
          [
            _c("el-tab-pane", {
              attrs: { label: "基本使用说明", name: "usage-desc" }
            }),
            _vm._v(" "),
            _c("el-tab-pane", {
              attrs: { label: "api接口（分组）", name: "tree-list" }
            }),
            _vm._v(" "),
            _c("el-tab-pane", {
              attrs: { label: "api接口（全部）", name: "conf-list" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { position: "absolute", top: "0", right: "0" } },
          [
            _c(
              "el-button",
              {
                attrs: { size: "mini" },
                on: {
                  click: function($event) {
                    _vm.openOpenPageList()
                  }
                }
              },
              [_vm._v("可授权访问的页面")]
            ),
            _vm._v(" "),
            _c("el-divider", { attrs: { direction: "vertical" } }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { size: "mini" },
                on: {
                  click: function($event) {
                    _vm.openSysJointPage()
                  }
                }
              },
              [_vm._v("平台/商户 对接点")]
            ),
            _vm._v(" "),
            _c("el-divider", { attrs: { direction: "vertical" } }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { size: "mini" },
                on: {
                  click: function($event) {
                    _vm.openFeeShareCalcDlg()
                  }
                }
              },
              [_vm._v("费用分摊/误差平衡")]
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "body",
        staticStyle: { "overflow-y": "auto" },
        style: { height: _vm.routerBodyHeight + "px" }
      },
      [_c("router-view")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e03b3af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e03b3af","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/apiDoc/ApiRootPage.vue
// module id = 858
// module chunks = 16